/** Rows that may carry the identifier as `registrationId` and/or `value` (form or API drift). */
export type RegistrationIdStringSource = {
  readonly registrationId?: string
  readonly value?: string
}

/**
 * Resolve one display/persistence string from `registrationId` and/or `value`: prefer non-empty
 * `registrationId`, then non-empty `value`, then whichever string field is present.
 */
export function registrationIdStringFromRow(
  row: RegistrationIdStringSource
): string {
  const fromRegistrationId = row.registrationId
  if (
    typeof fromRegistrationId === "string" &&
    fromRegistrationId.length > 0
  ) {
    return fromRegistrationId
  }
  const fromValue = row.value
  if (typeof fromValue === "string" && fromValue.length > 0) {
    return fromValue
  }
  if (typeof fromRegistrationId === "string") {
    return fromRegistrationId
  }
  if (typeof fromValue === "string") {
    return fromValue
  }
  return ""
}
